import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserApi } from '../../api';
import { UserGridService } from '../../api/user-grid.service';
import { User, UserMappingOption } from '../../shared';
import { UserAction } from '../../shared/enum/mapping-mode.enum';

import { FilterOperationModel, LoadOptions } from '../../shared/models/shared.model';

@Component({
	selector: 'user-management',
	templateUrl: 'user-management.component.html',
})
export class UserManagementComponent implements OnInit, OnDestroy {
	@ViewChild('userManagmentGrid') userManagmentGrid: DxDataGridComponent;

	public dataSource = {};
	public currentUser: User;

	private _destroyed$ = new Subject();
	constructor(
		private userGridService: UserGridService,
		private userService: UserApi,
	) {}

	ngOnInit() {
		this.currentUser = this.userService.logonUser;
		this.dataSource = new CustomStore({
			key: 'UserId',
			load: (loadOptions: any) => {
				const filter = this.formatFilterOperators(loadOptions.filter);
				const finalOptions: LoadOptions = loadOptions;
				finalOptions.filter = filter;
				//   finalOptions.extraParams = this.extraFilteringOptions;

				return this.userGridService
					.getCompanyMappingGrid(finalOptions)
					.toPromise()
					.then((data: any) => {
						return {
							data: data.data,
							totalCount: data.totalCount,
							summary: data.summary,
							groupCount: data.groupCount,
						};
					})
					.catch((error) => {
						throw new Error('Data Loading Error');
					});
			},
		});
	}

	formatFilterOperators(param: any[]) {
		if (!param) {
			return null;
		}

		const res: FilterOperationModel[] = [];
		const isAnd = param.includes('and');
		const isOr = param.includes('or');

		if (isAnd || isOr) {
			const condition = isAnd ? 'and' : 'or';
			param.forEach((item) => {
				if (item !== 'and' && item !== 'or') {
					const operationType = this.getTypeOfValue(item[2]);

					res.push({
						column: item[0],
						operation: item[1],
						value: item[2].toLocaleString(),
						type: operationType,
						condition: condition,
					});
				} else {
				}
			});
		} else {
			const operationType = this.getTypeOfValue(param[2]);
			res.push({
				column: param[0],
				operation: param[1],
				value: param[2].toLocaleString(),
				type: operationType,
			});
		}

		return res;
	}

	getTypeOfValue(value) {
		let operationType = 'string';
		if (typeof value === 'number') {
			operationType = 'number';
		}
		if (typeof value === 'string') {
			operationType = 'string';
		}
		return operationType;
	}

	customizeUserId(cellInfo) {
		const idStr = 'U_000';
		const cellValue = String(cellInfo.value);
		const index = idStr.length - cellValue.length;
		const finalText = idStr.slice(0, index) + cellValue;
		return finalText;
	}

	deactivate() {
		const mappingData: UserMappingOption = {};
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = UserAction.Deactivate;
		this.userGridService.mappingAction(mappingData)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((res) => {
				this.refreshUserGrid();
			});
	}

	reactivate() {
		const mappingData: UserMappingOption = {};
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = UserAction.Reactivate;
		this.userGridService.mappingAction(mappingData)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((res) => {
				this.refreshUserGrid();
			});
	}

	promote() {
		const mappingData: UserMappingOption = {};
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = UserAction.Promote;
		this.userGridService.mappingAction(mappingData)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((res) => {
				this.refreshUserGrid();
			});
	}

	demote() {
		const mappingData: UserMappingOption = {};
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = UserAction.Demote;
		this.userGridService.mappingAction(mappingData)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((res) => {
				this.refreshUserGrid();
			});
	}

	private refreshUserGrid() {
		this.userManagmentGrid.instance.refresh();
	}

	ngOnDestroy() {
		this._destroyed$.next(null);
		this._destroyed$.complete();
	}
}
